"use client";
import "../chunk-GOCCUU3Z.js";
import { UAParser } from "ua-parser-js";
function useUserAgent() {
  const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : void 0;
  return UAParser(userAgent);
}
export {
  useUserAgent
};
